import M from 'backbone.marionette'
export const TestView = M.View.extend({
    template: _.template(''),
    initialize: function(){

    }
})